import service from './Setting'



export const GetAdvertisement = (obj) => service.get('/Advertisement/GetCarouselAdvertisements',{params:obj});
